module.exports = __webpack_public_path__ + "img/img2.dc31966b.png";